/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


document.querySelectorAll('.swatch__button').forEach(swatch => {
  swatch.addEventListener('mouseover', () => {
    const variantId = swatch.dataset.variantId;

    // Set all images to opacity 0
    const imageContainers = document.querySelectorAll('.product-item__bg__inner');
    imageContainers.forEach(container => {
      container.style.opacity = '0';
    });

    // Set the hovered swatch's corresponding image to opacity 1
    const targetImage = document.querySelector(`.product-item__bg__inner[data-variant-id="${variantId}"]`);
    if (targetImage) {
      targetImage.style.opacity = '1';
    }
  });

  swatch.addEventListener('mouseout', () => {
    const imageContainers = document.querySelectorAll('.product-item__bg__inner');
    imageContainers.forEach(container => {
      container.style.opacity = '0'; // Reset all images to opacity 0
    });
  });
});







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
